module.exports = __webpack_public_path__ + "img/biaoqian_jiaqizhan.a1d4eb9d.png";